import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoBuey = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Buey - Predicciones Diarias | Dstino</title>
        <meta name="description" content="Horóscopo chino del signo Buey. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Buey." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="buey" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Buey</h1>
              <p className="text-muted-foreground">Años: 1925, 1937, 1949, 1961, 1973, 1985, 1997, 2009, 2021</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu lealtad y constancia brillan especialmente hoy, Buey. Las parejas disfrutarán de momentos de estabilidad y confianza mutua. Los solteros podrían conocer a alguien que comparta sus valores profundos.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu perseverancia dará frutos hoy. Los proyectos que has estado cultivando con paciencia mostrarán progreso significativo. Tu ética de trabajo será notada y apreciada.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu fortaleza física es admirable, pero no olvides descansar. Escucha las señales de tu cuerpo y permite tiempo para la recuperación entre tus rutinas de trabajo intenso.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Un día perfecto para fortalecer compromisos. Tu naturaleza confiable hará que tu pareja se sienta segura y amada. Es buen momento para conversaciones importantes sobre el futuro.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será productivo. Tu capacidad para mantenerte enfocado en metas a largo plazo te ayudará a avanzar en proyectos importantes. Mantén tu método sistemático.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu resistencia está en buen estado. Continúa con tus rutinas saludables, pero considera agregar ejercicios de flexibilidad para complementar tu fortaleza natural.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana de consolidación en el amor. Tu paciencia y dedicación crearán una base sólida para relaciones duraderas. Los solteros atraerán a personas serias y comprometidas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana verás resultados tangibles de tu trabajo duro. Tu enfoque metódico y determinación te llevarán a completar objetivos importantes. Reconocimiento profesional en camino.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén tu rutina constante pero no te sobrecargues. Tu naturaleza trabajadora puede llevarte al agotamiento. Programa descansos regulares y tiempo para relajarte.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoBuey;
